<div class="sidenav-content" cdkScrollable *ngIf="!submitting; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register' | translate) + getLongType()">
		<button type="button" mat-flat-button (click)="saveGuarantee($event)"
			[disabled]="attachmentEditor.updating">
			<span translate>issue.save.as.drafts</span>
			<mat-icon class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button type="submit" mat-flat-button color="primary" (click)="goToNextStep()"
			[disabled]="!canGoToNextStep()">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<copo-feedback-error></copo-feedback-error>
	<form class="copo-form-container copo-grid" [formGroup]="partsForm">
		<copo-stepper class="copo-stepper-container" [steps]="steps" (stepClicked)="onStepClicked($event)">
		</copo-stepper>
	<div class="copo-grid-row global-attachment-row">
		<div class="copo-grid-row-column">
			<div class="attachment-workspace">
				<div class="attachment-workspace-header">
					<div class="attachment-workspace-title" translate>guarantee.attachment.title</div>
					<div class="attachment-workspace-description" translate>guarantee.attachment.description</div>
				</div>
				<div class="attachment-upload-area">
					<copo-file-upload class="file-upload" [files]="[]"
						[fileErrors]="attachmentErrors()"
						[dragAndDropLabel]="('issue.drag.and.drop.files' | translate)"
						[orLabel]="('upload.or' | translate)"
						[browseFilesLabel]="('issue.attach.documents' | translate)"
						[fileUploadNote]="('guarantee.attachment.limit' | translate)"
						(filesAdded)="addAttachments($event)">
					</copo-file-upload>
				</div>
				<div class="attachment-category-panel" *ngIf="activeAttachments().length > 0">
				<div class="attachment-category-panel-header">
					<span class="attachment-category-panel-title" translate>guarantee.attachment.uploaded.title</span>
					<span class="attachment-category-panel-badge">{{ activeAttachments().length }}</span>
				</div>
				<div class="attachment-category-panel-columns">
					<span class="attachment-category-panel-col-file" translate>guarantee.attachment.column.file</span>
					<span class="attachment-category-panel-col-size" translate>guarantee.attachment.column.size</span>
					<span class="attachment-category-panel-col-type" translate>guarantee.attachment.category.label</span>
					<span class="attachment-category-panel-col-actions" translate>guarantee.attachment.column.actions</span>
				</div>
				<div class="attachment-category-row" *ngFor="let attachment of activeAttachments()">
					<a class="attachment-category-row-link" target="_blank" rel="noopener"
						[href]="getAttachmentUrl(guarantee.id, attachment) | copoSafeUrl"
						(click)="showAttachment($event, attachment)">
						<mat-icon svgIcon="attachment_popup_open_gallery" class="attachment-category-row-icon"></mat-icon>
						<span class="attachment-category-row-name">{{ attachment.name }}</span>
					</a>
					<span class="attachment-category-row-size">{{ formatSize(attachment) }}</span>
					<mat-form-field class="attachment-category-row-select"
						appearance="outline" subscriptSizing="dynamic">
						<mat-label translate>guarantee.attachment.category.label</mat-label>
						<mat-select [value]="attachmentEditor.getCategory(attachment)"
							[disabled]="attachmentEditor.updating || !attachmentEditor.isCategoryEditable(attachment, guarantee)"
							(selectionChange)="attachmentEditor.setCategory(guarantee, attachment, $event.value)">
							<mat-option value="Other">
								<span translate>guarantee.attachment.category.other</span>
							</mat-option>
							<mat-option *ngIf="isSoilAnalysisRequired()" value="SoilAnalysis">
								<span translate>guarantee.attachment.category.soil</span>
							</mat-option>
							<mat-option *ngIf="isWaterAnalysisRequired()" value="WaterAnalysis">
								<span translate>guarantee.attachment.category.water</span>
							</mat-option>
						</mat-select>
					</mat-form-field>
					<button type="button" mat-icon-button class="attachment-category-row-delete"
						(click)="removeAttachmentEntity(attachment)">
						<mat-icon svgIcon="md:close"></mat-icon>
					</button>
				</div>
			</div>
				<div class="attachment-missing-warning" *ngIf="hasAnyMissingCategory()">
					<mat-icon svgIcon="alert" class="attachment-missing-warning-icon"></mat-icon>
					<div class="attachment-missing-warning-text">
						<div class="attachment-missing-warning-title" translate>guarantee.attachment.missing.title</div>
						<div class="attachment-missing-warning-item" *ngIf="isSoilDocMissing()" translate>
							guarantee.attachment.missing.soil
						</div>
						<div class="attachment-missing-warning-item" *ngIf="isWaterDocMissing()" translate>
							guarantee.attachment.missing.water
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="guarantee.applicationType === 'Organic Coating'">
		<div class="copo-grid-row ">
			<div class="copo-grid-row-column">
				<h2 class="copo-grid-row-header-top-margin" translate>guarantee.requested</h2>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-guarantee-duration-inline">
				<mat-checkbox labelPosition="after" [formControl]="typeOfGuaGrOutdoorFormControl"
					(change)="typeOfGuaGrOutdoorCheckboxChanged($event.checked)">
					<span class="checkbox-label-wrapped" translate>guarantee.requested.type.outdoor</span>
				</mat-checkbox>
				<mat-form-field class="copo-grid-row-column-input" *ngIf="typeOfGuaGrOutdoorFormControl.value">
					<mat-label translate>guarantee.duration.years.outdoor</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off" maxlength="5"
						[formControl]="outdoorGuaranteeDurationFormControl" (change)="outdoorGuaranteeDurationChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
				</mat-form-field>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-guarantee-duration-inline">
				<mat-checkbox labelPosition="after" [formControl]="typeofGuaGrIndoorFormControl"
					(change)="typeofGuaGrIndoorCheckboxChanged($event.checked)">
					<span class="checkbox-label-wrapped" translate>guarantee.requested.type.indoor</span>
				</mat-checkbox>
				<mat-form-field class="copo-grid-row-column-input" *ngIf="typeofGuaGrIndoorFormControl.value">
					<mat-label translate>guarantee.duration.years.indoor</mat-label>
					<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off" maxlength="5"
						[formControl]="indoorGuaranteeDurationFormControl" (change)="indoorGuaranteeDurationChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
				</mat-form-field>
			</div>
		</div>
		<div class="copo-grid-row-radio">
			<div class="copo-grid-row-column copo-grid-row-column-left-margin">
				<h2 translate>guarantee.open.building</h2>
			</div>
			<div class="copo-grid-row-column">
				<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
					[formControl]="typeOfGUAOpenBuildingYesFormControl" (change)="typeOfGUAOpenBuildingYesChanged($event)">
					<mat-radio-button class="copo-guarantee-radio" [value]="true">
						<span translate>guarantee.radio.yes</span>
					</mat-radio-button>
					<mat-radio-button class="copo-guarantee-radio" [value]="false">
						<span translate>guarantee.radio.no</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
		</div>
		<ng-container *ngIf="typeOfGUAOpenBuildingYesFormControl.value === true">
			<div class="copo-grid-row copo-left-margin copo-top-none">
				<div class="copo-grid-row-column">
					<mat-form-field>
						<mat-label translate>guarantee.open.building.specify</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
							[formControl]="typeOfGUAOpenBuildingYesSpecifyFormControl" (change)="typeOfGUAOpenBuildingYesSpecifyChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
						</mat-icon>
					</mat-form-field>
				</div>
			</div>
		</ng-container>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
					(change)="ocRoofingCheckboxChange($event.checked)"
					[formControl]="ocRoofingFormControl">
					<h2 translate>guarantee.roofing</h2>
				</mat-checkbox>
				<ng-container *ngIf="ocRoofingFormControl.value === true">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
								(change)="roofingDeckingRoofCheckboxChange($event.checked)"
								[formControl]="roofingDeckingRoofFormControl">
								<span class="checkbox-label-wrapped" translate>guarantee.roofing.decking.roof</span>
							</mat-checkbox>
							<ng-container *ngIf="roofingDeckingRoofFormControl.value === true">
								<div class="copo-roofing-cladding-fields grid-template-columns">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingDRSubstrateThicknessFormControl" (change)="roofingDRSubstrateThicknessChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingDRDesiredCoatingFormControl" (change)="roofingDRDesiredCoatingChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingDRDesiredBackCoatingFormControl" (change)="roofingDRDesiredBackCoatingChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingDRMetallicCoatingWeightFormControl" (change)="roofingDRMetallicCoatingWeightChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.color</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingDRColorFormControl" (change)="roofingDRColorChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
												[formControl]="roofingDRSurfaceFormControl" (change)="roofingDRSurfaceChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing.roofslope</mat-label>
											<input type="text" copoInputNumber matInput spellcheck="false" autocomplete="off" maxlength="2"
												[formControl]="roofingDRRoofslopeFormControl" (change)="roofingDRRoofslopeChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
								(change)="roofingSingleSkinRoofCheckboxChange($event.checked)"
								[formControl]="roofingSingleSkinRoofFormControl">
								<span class="checkbox-label-wrapped" translate>guarantee.single.skin.roof</span>
							</mat-checkbox>
							<ng-container *ngIf="roofingSingleSkinRoofFormControl.value === true">
								<div class="copo-roofing-cladding-fields grid-template-columns">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingSSRSubstrateThicknessFormControl" (change)="roofingSSRSubstrateThicknessChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingSSRDesiredCoatingFormControl" (change)="roofingSSRDesiredCoatingChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingSSRDesiredBackCoatingFormControl" (change)="roofingSSRDesiredBackCoatingChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingSSRMetallicCoatingWeightFormControl" (change)="roofingSSRMetallicCoatingWeightChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.color</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="roofingSSRColorFormControl" (change)="roofingSSRColorChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
												[formControl]="roofingSSRSurfaceFormControl" (change)="roofingSSRSurfaceChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing.roofslope</mat-label>
											<input type="text" copoInputNumber matInput spellcheck="false" autocomplete="off" maxlength="2"
												[formControl]="roofingSSRRoofslopeFormControl" (change)="roofingSSRRoofslopeChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
								(change)="roofingDoubleSkinRoofCheckboxChange($event.checked)"
								[formControl]="roofingDoubleSkinRoofFormControl">
								<span class="checkbox-label-wrapped" translate>guarantee.double.skin.roof</span>
							</mat-checkbox>
							<ng-container *ngIf="roofingDoubleSkinRoofFormControl.value === true">
								<div class="copo-grid-row copo-padding-top">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.external.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsresSubstrateThicknessFormControl" (change)="roofingDsresSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsresDesiredCoatingFormControl" (change)="roofingDsresDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsresDesiredBackCoatingFormControl" (change)="roofingDsresDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsresMetallicCoatingWeightFormControl" (change)="roofingDsresMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsrEsColorFormControl" (change)="roofingDsrEsColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.internal.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsrisSubstrateThicknessFormControl" (change)="roofingDsrisSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsrisDesiredCoatingFormControl" (change)="roofingDsrisDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsrisDesiredBackCoatingFormControl" (change)="roofingDsrisDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsrisMetallicCoatingWeightFormControl" (change)="roofingDsrisMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingDsrIsColorFormControl" (change)="roofingDsrIsColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
												[formControl]="roofingDSRSurfaceFormControl" (change)="roofingDSRSurfaceChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing.roofslope</mat-label>
											<input type="text" copoInputNumber matInput spellcheck="false" autocomplete="off" maxlength="2"
												[formControl]="roofingDSRRoofslopeFormControl" (change)="roofingDSRRoofslopeChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
								(change)="roofingSandwichPanelsBuiltUpSysCheckboxChange($event.checked)"
								[formControl]="roofingSandwichPanelsBuiltUpSysFormControl">
								<span class="checkbox-label-wrapped" translate>guarantee.sandwich.panel</span>
							</mat-checkbox>
							<ng-container *ngIf="roofingSandwichPanelsBuiltUpSysFormControl.value === true">
								<div class="copo-grid-row copo-padding-top">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.external.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPESSubstrateThicknessFormControl" (change)="roofingSPESSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPESDesiredCoatingFormControl" (change)="roofingSPESDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPESDesiredBackCoatingFormControl" (change)="roofingSPESDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPESMetallicCoatingWeightFormControl" (change)="roofingSPESMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPESColorFormControl" (change)="roofingSPESColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.internal.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPISSubstrateThicknessFormControl" (change)="roofingSPISSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPISDesiredCoatingFormControl" (change)="roofingSPISDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPISDesiredBackCoatingFormControl" (change)="roofingSPISDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPISMetallicCoatingWeightFormControl" (change)="roofingSPISMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="roofingSPISColorFormControl" (change)="roofingSPISColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
												[formControl]="roofingSPSurfaceFormControl" (change)="roofingSPSurfaceChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing.roofslope</mat-label>
											<input type="text" copoInputNumber matInput spellcheck="false" autocomplete="off" maxlength="2"
												[formControl]="roofingSPRoofslopeFormControl" (change)="roofingSPRoofslopeChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.insulation</span>
										<div class="copo-grid-row">
											<div class="copo-grid-row-column">
												<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
													(change)="roofingSPInsulationPUCheckboxChange($event.checked)"
													[formControl]="roofingSPInsulationPUFormControl">
													<span class="checkbox-label-wrapped" translate>guarantee.pu.insulation</span>
												</mat-checkbox>
											</div>
										</div>
										<div class="copo-grid-row">
											<div class="copo-grid-row-column">
												<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
													(change)="roofingSPInsulationPIRCheckboxChange($event.checked)"
													[formControl]="roofingSPInsulationPIRFormControl">
													<span class="checkbox-label-wrapped" translate>guarantee.pir.insulation</span>
												</mat-checkbox>
											</div>
										</div>
										<div class="copo-grid-row">
											<div class="copo-grid-row-column">
												<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
													(change)="roofingSPInsulationMineralWoolCheckboxChange($event.checked)"
													[formControl]="roofingSPInsulationMineralWoolFormControl">
													<span class="checkbox-label-wrapped" translate>guarantee.mineral.wool.insulation</span>
												</mat-checkbox>
											</div>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="copo-grid-row copo-align">
						<div class="copo-roofing-cladding-column">
							<span translate>guarantee.roofing-cladding.overlapping</span>
						</div>
						<div class="copo-grid-row-radio copo-margin-bottom-none">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="roofingOverlappingFormControl" (change)="roofingOverlappingChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<div class="copo-grid-row copo-align">
						<div class="copo-roofing-cladding-column">
							<span translate>guarantee.roofing-cladding.perforation</span>
						</div>
						<div class="copo-grid-row-radio copo-margin-bottom-none">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="roofingPerforationYesFormControl" (change)="roofingPerforationYesChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<ng-container *ngIf="roofingPerforationYesFormControl.value === 'true'">
						<div class="copo-grid-row copo-left-margin">
							<div class="copo-grid-row-column">
								<mat-form-field>
									<mat-label translate>guarantee.specify.perforation.scheme</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
										[formControl]="roofingPerforationYesSpecifyFormControl" (change)="roofingPerforationYesSpecifyChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
									</mat-icon>
								</mat-form-field>
							</div>
						</div>
					</ng-container>
					<div class="copo-grid-row copo-align">
						<div class="copo-roofing-cladding-column copo-margin-bottom-none">
							<span translate>guarantee.roofing-cladding.pv.solar.roof</span>
						</div>
						<div class="copo-grid-row-radio copo-margin-bottom-none">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="roofingPVSolarRoofFormControl" (change)="roofingPVSolarRoofChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<div class="copo-grid-row copo-align">
						<div class="copo-roofing-cladding-column">
							<span translate>guarantee.roofing-cladding.anti-condensation.felt</span>
						</div>
						<div class="copo-grid-row-radio copo-margin-bottom-none">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="roofingAntiCondensationFeltFormControl" (change)="roofingAntiCondensationFeltChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
					(change)="cladCheckboxChange($event.checked)"
					[formControl]="cladFormControl">
					<h2 translate>guarantee.cladding</h2>
				</mat-checkbox>
				<ng-container *ngIf="cladFormControl.value === true">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
								(change)="cladSingleSkinCheckboxChange($event.checked)"
								[formControl]="cladSingleSkinFormControl">
								<span class="checkbox-label-wrapped" translate>guarantee.cladding.single.skin</span>
							</mat-checkbox>
							<ng-container *ngIf="cladSingleSkinFormControl.value === true">
								<div class="copo-roofing-cladding-fields grid-template-columns">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="cladSSSubstrateThicknessFormControl" (change)="cladSSSubstrateThicknessChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="cladSSDesiredCoatingFormControl" (change)="cladSSDesiredCoatingChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="cladSSDesiredBackCoatingFormControl" (change)="cladSSDesiredBackCoatingChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="cladSSMetallicCoatingWeightFormControl" (change)="cladSSMetallicCoatingWeightChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.color</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
												[formControl]="cladSSColorFormControl" (change)="cladSSColorChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
												[formControl]="cladSSSurfaceFormControl" (change)="cladSSSurfaceChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
								(change)="cladDoubleSkinCheckboxChange($event.checked)"
								[formControl]="cladDoubleSkinFormControl">
								<span class="checkbox-label-wrapped" translate>guarantee.cladding.double.skin</span>
							</mat-checkbox>
							<ng-container *ngIf="cladDoubleSkinFormControl.value === true">
								<div class="copo-grid-row copo-padding-top">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.external.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSESSubstrateThicknessFormControl" (change)="cladDSESSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSESDesiredCoatingFormControl" (change)="cladDSESDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSESDesiredBackCoatingFormControl" (change)="cladDSESDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSESMetallicCoatingWeightFormControl" (change)="cladDSESMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSESColorFormControl" (change)="cladDSESColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
														[formControl]="cladDSESSurfaceFormControl" (change)="cladDSESSurfaceChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.internal.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSISSubstrateThicknessFormControl" (change)="cladDSISSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSISDesiredCoatingFormControl" (change)="cladDSISDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSISDesiredBackCoatingFormControl" (change)="cladDSISDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSISMetallicCoatingWeightFormControl" (change)="cladDSISMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladDSISColorFormControl" (change)="cladDSISColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
														[formControl]="cladDSISSurfaceFormControl" (change)="cladDSISSurfaceChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
								(change)="cladSandwichPanelsBuiltUpSysCheckboxChange($event.checked)"
								[formControl]="cladSandwichPanelsBuiltUpSysFormControl">
								<span class="checkbox-label-wrapped" translate>guarantee.sandwich.panel</span>
							</mat-checkbox>
							<ng-container *ngIf="cladSandwichPanelsBuiltUpSysFormControl.value === true">
								<div class="copo-grid-row copo-padding-top">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.external.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPESSubstrateThicknessFormControl" (change)="cladSPESSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPESDesiredCoatingFormControl" (change)="cladSPESDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPESDesiredBackCoatingFormControl" (change)="cladSPESDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPESMetallicCoatingWeightFormControl" (change)="cladSPESMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPESColorFormControl" (change)="cladSPESColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.internal.skin</span>
										<div class="copo-roofing-cladding-fields grid-template-columns">
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.substrate.thickness</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPISSubstrateThicknessFormControl" (change)="cladSPISSubstrateThicknessChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.coating</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPISDesiredCoatingFormControl" (change)="cladSPISDesiredCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.desired.back.coat</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPISDesiredBackCoatingFormControl" (change)="cladSPISDesiredBackCoatingChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.metallic.coating.weight</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPISMetallicCoatingWeightFormControl" (change)="cladSPISMetallicCoatingWeightChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
											<div class="copo-grid-row-column">
												<mat-form-field>
													<mat-label translate>guarantee.roofing-cladding.color</mat-label>
													<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
														[formControl]="cladSPISColorFormControl" (change)="cladSPISColorChanged($event)">
													<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
													</mat-icon>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="copo-grid-row-column">
									<mat-form-field>
										<mat-label translate>guarantee.roofing-cladding.surface</mat-label>
										<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
											[formControl]="cladSPSurfaceFormControl" (change)="cladSPSurfaceChanged($event)">
										<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
										</mat-icon>
									</mat-form-field>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<span translate>guarantee.roofing-cladding.insulation</span>
										<div class="copo-grid-row">
											<div class="copo-grid-row-column">
												<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
													(change)="cladSPInsulationPUCheckboxChange($event.checked)"
													[formControl]="cladSPInsulationPUFormControl">
													<span class="checkbox-label-wrapped" translate>guarantee.pu.insulation</span>
												</mat-checkbox>
											</div>
										</div>
										<div class="copo-grid-row">
											<div class="copo-grid-row-column">
												<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
													(change)="cladSPInsulationPIRCheckboxChange($event.checked)"
													[formControl]="cladSPInsulationPIRFormControl">
													<span class="checkbox-label-wrapped" translate>guarantee.pir.insulation</span>
												</mat-checkbox>
											</div>
										</div>
										<div class="copo-grid-row">
											<div class="copo-grid-row-column">
												<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
													(change)="cladSPInsulationMineralWoolCheckboxChange($event.checked)"
													[formControl]="cladSPInsulationMineralWoolFormControl">
													<span class="checkbox-label-wrapped" translate>guarantee.mineral.wool.insulation</span>
												</mat-checkbox>
											</div>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="copo-grid-row copo-align">
						<div class="copo-roofing-cladding-column">
							<span translate>guarantee.roofing-cladding.overlapping</span>
						</div>
						<div class="copo-grid-row-radio copo-margin-bottom-none">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="cladOverlappingFormControl" (change)="cladOverlappingChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class="copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<div class="copo-margin-bottom">
						<div class="copo-grid-row copo-align">
							<div class="copo-roofing-cladding-column">
								<span translate>guarantee.roofing-cladding.perforation</span>
							</div>
							<div class="copo-grid-row-radio copo-margin-bottom-none">
								<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
									[formControl]="cladPerforationYesFormControl" (change)="cladPerforationYesChanged($event)">
									<mat-radio-button class="copo-guarantee-radio" value="true">
										<span translate>guarantee.radio.yes</span>
									</mat-radio-button>
									<mat-radio-button class="copo-guarantee-radio" value="false">
										<span translate>guarantee.radio.no</span>
									</mat-radio-button>
									<mat-radio-button class="copo-guarantee-radio" value="">
										<span translate>guarantee.radio.na</span>
									</mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
						<ng-container *ngIf="cladPerforationYesFormControl.value === 'true'">
							<div class="copo-grid-row copo-left-margin">
								<div class="copo-grid-row-column">
									<mat-form-field>
										<mat-label translate>guarantee.specify.perforation.scheme</mat-label>
										<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
											[formControl]="cladPerforationYesSpecifyFormControl" (change)="cladPerforationYesSpecifyChanged($event)">
										<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
										</mat-icon>
									</mat-form-field>
								</div>
							</div>
						</ng-container>
					</div>
					<div class="copo-grid-row ">
						<div class="copo-grid-row-column">
							<span class="copo-grid-row-header-top-margin" translate>guarantee.direction.of.cladding.installation</span>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox labelPosition="after" [formControl]="cladDirectionOfInstallationFormControl"
								(change)="cladDirectionOfInstallationCheckboxChanged($event.checked)">
								<span class="checkbox-label-wrapped" translate>guarantee.installation.direction.horizontal</span>
							</mat-checkbox>
						</div>
					</div>
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-checkbox labelPosition="after" [formControl]="cladVerticalFormControl"
								(change)="cladVerticalCheckboxChanged($event.checked)">
								<span class="checkbox-label-wrapped" translate>guarantee.installation.direction.vertical</span>
							</mat-checkbox>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
					(change)="othersAntiCondensationFeltCheckboxChange($event.checked)"
					[formControl]="othersAntiCondensationFeltFormControl">
					<h2 translate>guarantee.Others</h2>
				</mat-checkbox>
				<ng-container *ngIf="othersAntiCondensationFeltFormControl.value === true">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<mat-form-field>
								<mat-label translate>guarantee.others.please.specify</mat-label>
								<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
									[formControl]="othersSpecifyAntiCondensationFeltFormControl" (change)="othersSpecifyAntiCondensationFeltChanged($event)">
								<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
								</mat-icon>
							</mat-form-field>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<h2 translate>guarantee.other.materials.used</h2>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
					(change)="omuRoofCladmadeWithProductCheckboxChange($event.checked)"
					[formControl]="omuRoofCladmadeWithProductFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.roofing-cladding.made.with.product</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
					(change)="omuUseofMaterialCementBreezeblocksCheckboxChange($event.checked)"
					[formControl]="omuUseofMaterialCementBreezeblocksFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.use.of.other.materials</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-left-margin">
				<mat-form-field class="specify-material-width">
					<mat-label translate>guarantee.roofing.specify.material.type</mat-label>
					<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
						[formControl]="omuInRoofingFormControl" (change)="omuInRoofingChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-left-margin">
				<mat-form-field class="specify-material-width">
					<mat-label translate>guarantee.cladding.specify.material.type</mat-label>
					<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
						[formControl]="omuInCladdingFormControl" (change)="omuInCladdingChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
			</div>
		</div>
	</div>
	<ng-container *ngIf="guarantee.applicationType !== 'Organic Coating'">
		<div *ngIf="guarantee.applicationType === 'Magnelis-Solar'">
			<div class="copo-grid-row " >
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.atmospheric.corrosion</h2>
				</div>
			</div>
			<div class="copo-grid-row-radio" >
				<div class="copo-grid-row-column copo-grid-row-column-left-margin">
					<span translate>guarantee.upper.structure</span>
				</div>
				<div class="copo-grid-row-column">
					<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
						[formControl]="upperStructureGuaranteeFormControl" (change)="onUpperStructureGuarantee($event)">
						<mat-radio-button class="copo-guarantee-radio" [value]="true">
							<span translate>guarantee.radio.yes</span>
						</mat-radio-button>
						<mat-radio-button class=" copo-guarantee-radio" [value]="false">
							<span translate>guarantee.radio.no</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
		</div>
		<ng-container *ngIf="guarantee.applicationType !== 'Magnelis-Solar' || upperStructureGuaranteeFormControl.value === true">
		<ng-container *ngIf="guarantee.applicationType === 'Magnelis-Solar'; else otherBuilding">
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.magnelis.upper.structure</h2>
				</div>
			</div>
		</ng-container>
		<ng-template #otherBuilding>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.magnelis</h2>
				</div>
			</div>
		</ng-template>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onMagnelisZM310Change($event.checked)"
					[formControl]="magnelisZM310FormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm310</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onMagnelisZM430Change($event.checked)"
					[formControl]="magnelisZM430FormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm430</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row" *ngIf="guarantee.applicationType === 'Magnelis-Solar'; else otherBuildingType">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onMagnelisZM620Change($event.checked)"
					[formControl]="magnelisZM620FormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm620</span>
				</mat-checkbox>
			</div>
			<div class="copo-grid-row" *ngIf="user.hasServiceParameterEqualsTo('PGNTE','magnelissolar','Spain')">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" (change)="onMagnelisOtherChange($event.checked)"
						[formControl]="magnelisOtherFormControl">
						<span class="checkbox-label-wrapped" translate>guarantee.magnelis.other</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row" *ngIf="user.hasServiceParameterEqualsTo('PGNTE','magnelissolar','Spain') && magnelisOtherFormControl.value">
				<div class="copo-grid-row-column">
					<mat-form-field>
						<mat-label translate>gurantee.other.coating.mass
						</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
							[formControl]="guaranteeCoatingMassFormControl" (change)="guaranteeCoatingMassChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
					</mat-form-field>
				</div>
			</div>
		</div>
		<ng-template #otherBuildingType>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" (change)="suggestedCoatingMassChanged($event.checked)"
						[formControl]="suggestedCoatingMassFormControl">
						<span class="checkbox-label-wrapped" translate>guarantee.suggested.coating.mass</span>
					</mat-checkbox>
				</div>
			</div>
		</ng-template>
		<div class="copo-grid-row">
			<mat-form-field class="copo-grid-row-column-input">
				<mat-label translate>gurantee.duration.years
				</mat-label>
				<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off" maxlength="5"
					[formControl]="guaranteeDurationFormControl" (change)="guaranteeDurationChanged($event)">
				<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
			</mat-form-field>
		</div>
		</ng-container>
		<div *ngIf="guarantee.applicationType === 'Magnelis-Solar'">
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.poles.soil</h2>
				</div>
			</div>
			<div class="copo-grid-row-radio">
				<div class="copo-grid-row-column copo-grid-row-column-left-margin">
					<span translate>guarantee.poles.magnelis</span>
				</div>
				<div class="copo-grid-row-column">
					<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
						[formControl]="polesGuaranteeFormControl" (change)="onPolesGuarantee($event)">
						<mat-radio-button class="copo-guarantee-radio" [value]="true">
							<span translate>guarantee.radio.yes</span>
						</mat-radio-button>
						<mat-radio-button class="copo-guarantee-radio" [value]="false">
							<span translate>guarantee.radio.no</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
			<ng-container *ngIf="polesGuaranteeFormControl.value === true">
				<div class="copo-grid-row ">
					<div class="copo-grid-row-column">
						<h2 translate>guarantee.magnelis.poles</h2>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" (change)="onPolesMagnelisZM430Change($event.checked)"
							[formControl]="polesMagnelisZM430FormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm430</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" (change)="onPolesMagnelisZM620Change($event.checked)"
							[formControl]="polesMagnelisZM620FormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm620</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" (change)="onPolesMagnelisZM800Change($event.checked)"
							[formControl]="polesMagnelisZM800FormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm800</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<mat-form-field class="copo-grid-row-column-input">
						<mat-label translate>gurantee.duration.years</mat-label>
						<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off" maxlength="5"
							[formControl]="poleGuaranteeDurationFormControl" (change)="poleGuaranteeDurationChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
					</mat-form-field>
				</div>
				<div class="copo-grid-row-radio">
					<div class="copo-grid-row-column copo-grid-row-column-left-margin">
						<span translate>guarantee.soil.analysis</span>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
							[formControl]="soilAnalysisFormControl" (change)="onSoilAnalysisChange($event)">
							<mat-radio-button class="copo-guarantee-radio" [value]="true">
								<span translate>guarantee.radio.yes</span>
							</mat-radio-button>
							<mat-radio-button class="copo-guarantee-radio" [value]="false">
								<span translate>guarantee.radio.no</span>
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
				<div class="copo-grid-row" *ngIf="soilAnalysisFormControl.value === true">
					<div class="copo-grid-row-column">
						<div class=" copo-outline-label" translate>guarantee.soil.document</div>
						<div class="guarantee-hint-callout">
							<mat-icon class="guarantee-hint-callout-icon" svgIcon="help_icon_grey"></mat-icon>
							<div class="guarantee-hint-callout-content">
								<div class="guarantee-hint-callout-text" translate>guarantee.soil.information</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.project.for.floating.solar</h2>
				</div>
			</div>
			<div class="copo-grid-row-radio">
				<div class="copo-grid-row-column copo-grid-row-column-left-margin">
					<span translate>guarantee.floating.solar.magnelis</span>
				</div>
				<div class="copo-grid-row-column">
					<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
						[formControl]="guaranteeForFloatingSolarMagnelisFormControl"
						(change)="onGuaranteeForFloatingSolarMagnelis($event)">
						<mat-radio-button class="copo-guarantee-radio" value="Yes">
							<span translate>guarantee.radio.yes</span>
						</mat-radio-button>
						<mat-radio-button class="copo-guarantee-radio" value="No">
							<span translate>guarantee.radio.no</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
			<ng-container *ngIf="guaranteeForFloatingSolarMagnelisFormControl.value === 'Yes'">
				<div class="copo-grid-row ">
					<div class="copo-grid-row-column">
						<h2 translate>guarantee.magnelis</h2>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" (change)="onFloatingSolarMagnelisZM430Change($event.checked)"
							[formControl]="floatingSolarMagnelisZM430FormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm430</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" (change)="onFloatingSolarMagnelisZM620Change($event.checked)"
							[formControl]="floatingSolarMagnelisZM620FormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm620</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" (change)="onFloatingSolarMagnelisZM800Change($event.checked)"
							[formControl]="floatingSolarMagnelisZM800FormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.magnelis.zm800</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<mat-form-field class="copo-grid-row-column-input">
						<mat-label translate>gurantee.duration.years
						</mat-label>
						<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off" maxlength="5"
							[formControl]="floatingPoleGuaranteeDurationFormControl"
							(change)="floatingPoleGuaranteeDurationChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
					</mat-form-field>
				</div>
				<div class="copo-grid-row-radio">
					<div class="copo-grid-row-column copo-grid-row-column-left-margin">
						<span translate>guarantee.water.analysis</span>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
							[formControl]="floatingSolarInstallationAnalysisFormControl"
							(change)="onFloatingSolarInstallationAnalysisChange($event)">
							<mat-radio-button class="copo-guarantee-radio" value="Yes">
								<span translate>guarantee.radio.yes</span>
							</mat-radio-button>
							<mat-radio-button class="copo-guarantee-radio" value="No">
								<span translate>guarantee.radio.no</span>
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
				<ng-container *ngIf="floatingSolarInstallationAnalysisFormControl.value === 'Yes'">
					<div class="copo-grid-row">
						<div class="copo-grid-row-column">
							<div class=" copo-outline-label" translate>guarantee.water.document</div>
							<div class="guarantee-hint-callout">
								<mat-icon class="guarantee-hint-callout-icon" svgIcon="help_icon_grey"></mat-icon>
								<div class="guarantee-hint-callout-content">
									<div class="guarantee-hint-callout-text" translate>guarantee.water.information</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
		<div class="copo-grid-row ">
			<div class="copo-grid-row-column">
				<h2 translate> guarantee.other.materials</h2>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onEntireMagnelisChange($event.checked)"
					[formControl]="entireMagnelisFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.structure</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onStainlessSteelPartsChange($event.checked)"
					[formControl]="stainlessSteelPartsFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.steel.parts</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onAluminiumPartsChange($event.checked)"
					[formControl]="aluminiumPartsFormControl">
					<span class="checkbox-label-wrapped" translate>guaranatee.aluminium.parts</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onFoundationsConcreteChange($event.checked)"
					[formControl]="foundationsConcreteFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.concrete.foundations</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row ">
			<div class="copo-grid-row-column">
				<h2 translate>guarantee.fastners</h2>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onStainlessSteelChange($event.checked)"
					[formControl]="stainlessSteelFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.stainless.steel</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onZincCoatedChange($event.checked)"
					[formControl]="zincCoatedSteelFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.zinc</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onOtherCoatingsSteelChange($event.checked)"
					[formControl]="otherCoatingsSteelFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.other.coatings</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="onAluminiumChange($event.checked)"
					[formControl]="aluminiumFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.aluminium</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
					(change)="contactPartsChanged($event.checked)"
					[formControl]="contactPartsFormControl">
					<span class="checkbox-label-wrapped" translate>guarantee.contact.parts</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row" *ngIf="contactPartsFormControl.value === true">
			<div class="copo-grid-row-column copo-grid-row-column-bottom-margin">
				<mat-form-field class="copo-grid-row-column-input">
					<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
						(change)="onMagnelisContactPartsCoatingChanged($event)"
						[value]="guarantee.magnelisContactPartsCoating"
						[formControl]="magnelisContactPartsCoatingFormControl">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after" [formControl]="contactPartsOtherFormControl"
				(change)="contactPartsOtherChanged($event.checked)">
					<span class="checkbox-label-wrapped" translate>guarantee.contact.orther.parts</span>
				</mat-checkbox>
			</div>
		</div>
		<div class="copo-grid-row" *ngIf="contactPartsOtherFormControl.value === true">
			<div class="copo-grid-row-column">
				<mat-form-field class="copo-grid-row-column-input">
					<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
						(change)="onMagnelisContactPartsOtherMaterialChanged($event)"
						[value]="guarantee.magnelisContactPartsOtherMaterial"
						[formControl]="magnelisContactPartsOtherMaterialFormControl">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
				<div class="copo-grid-row-column copo-grid-row-column-bottom-margin">
					<span translate>guarantee.contact</span>
				</div>
			</div>
		</div>
	</ng-container>
	<div class="add-button" *ngIf="guarantee.applicationType !== 'Organic Coating'">
		<h2 translate>guarantee.parts.magnelis</h2>
		<span class="add-text" translate>guarantee.add.parts</span>
		<button type="button" mat-mini-fab (click)="addNewPart()" class="add-color">
			<mat-icon color="accent" svgIcon="plus_button"></mat-icon>
		</button>
	</div>
	<div class="part-block part-block-normal" formArrayName="parts"  *ngIf="guarantee.applicationType !== 'Organic Coating'">
		<div class="part-block-item copo-dark-theme"
			*ngFor="let part of parts().controls; let i=index;" [formGroupName]="i">
			<mat-form-field>
				<mat-label translate>guarantee.designation</mat-label>
				<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
					formControlName="name" class="form-control">
				<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
				</mat-icon>
			</mat-form-field>
			<mat-form-field>
				<mat-label translate>guarantee.part.magnelis</mat-label>
				<input type="number"  matInput spellcheck="false" autocomplete="off"
				(keypress)="checkLength($event)"  (paste)="checkPasteLength($event)"
				formControlName="magnelisCoatingMass" class="form-control">
				<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
				</mat-icon>
			</mat-form-field>
			<mat-form-field>
				<mat-label translate>guarantee.sheet.thickness</mat-label>
				<input type="number" matInput spellcheck="false" autocomplete="off"
				(keypress)="checkLength($event)" (paste)="checkPasteLength($event)"
				formControlName="sheetThickness" class="form-control">
				<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
				</mat-icon>
			</mat-form-field>
			<mat-form-field *ngIf="guarantee.applicationType === 'Magnelis-Solar'">
				<mat-label translate>guarantee.part.corrosion</mat-label>
				<mat-select placeholder="Atmospheric" formControlName="corrosion" class="form-control">
					<mat-option *ngFor="let corrosionType of corrosionTypeValues" [value]="corrosionType.key">{{
						corrosionType.value.label | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field *ngIf="guarantee.applicationType === 'Magnelis-Other application'
						|| guarantee.applicationType === 'Magnelis-Building'">
				<mat-label translate>guarantee.epassivation.type</mat-label>
				<mat-select placeholder="E-Passivation®" formControlName="epassivationEasyfilm" class="form-control">
					<mat-option *ngFor="let epassiveValuesType of epassiveValues" [value]="epassiveValuesType.key">{{
						epassiveValuesType.value.label | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<div class="part-input-button">
				<mat-form-field *ngIf="guarantee.applicationType === 'Magnelis-Solar'">
					<mat-label translate>guarantee.fabrication</mat-label>
					<mat-select placeholder="Tubing + Laser" formControlName="fabricationProcess" class="form-control">
						<mat-option *ngFor="let fabricationProcesses of fabricationProcessValues"
							[value]="fabricationProcesses.key">{{fabricationProcesses.value.label | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field *ngIf="guarantee.applicationType === 'Magnelis-Other application'
				|| guarantee.applicationType === 'Magnelis-Building'">
					<mat-label translate>guarantee.fabrication</mat-label>
					<mat-select placeholder="Tubing + Laser" formControlName="fabricationProcess" class="form-control">
						<mat-option *ngFor="let fabricationProcesses of fabricationProcessOtherValues"
							[value]="fabricationProcesses.key">{{fabricationProcesses.value.label | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<button type="button" mat-mini-fab color="primary" (click)="parts().length === 1 ? clearLastPart() : removePart(i)"
					[matTooltip]="'quapp.action.delete' | translate">
					<mat-icon color="accent" svgIcon="garbage" class="garbage-icon"></mat-icon>
				</button>
			</div>
		</div>
	</div>
	<div class="copo-grid-row">
		<div class="copo-grid-row-column">
			<h2 translate>guarantee.additional.comments</h2>
		</div>
	</div>
	<div class="copo-grid-row copo-grid-row-stretch">
		<div class="copo-grid-row-column">
			<div class=" copo-outline-label" translate>guarantee.remarks</div>
			<mat-form-field class="outline-comment" appearance="outline">
				<textarea rows="3" class="textarea-no-resize" type="textarea" maxlength="255" cdkTextareaAutosize
					(change)="onCustomerAdditionalInformationChanged($event)"
					[value]="guarantee.customerAdditionalInformation"
					[formControl]="customerAdditionalInformationFormControl" matInput spellcheck="false"
					autocomplete="off">
				</textarea>
				<mat-hint align="end">{{customerAdditionalInformationFormControl.value.length || 0}}/255</mat-hint>
			</mat-form-field>
		</div>
	</div>
	</form>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>